import * as rdd from 'react-device-detect'
import { ReactNode, useState, CSSProperties, useEffect } from 'react'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import styled from '@emotion/styled'
import CloseIcon from 'assets/icons-gray/close.svg'

const StyledModal = styled(Box)`
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -o-sticky;
  position: -ms-sticky;
  position: sticky;
  max-width: 560px;
  padding: 32px;
  height: min-content;
  background: white;
  box-shadow: 0px 0px 10px rgba(18, 18, 18, 0.08);
  border-radius: 16px;
  margin: auto auto;
  max-height: 100vh;
  :focus {
    outline: none;
  }
`

export const CloseStyle = styled(Box)`
  position: absolute;
  top: 25px;
  right: 23px;
  width: 42px;
  height: 42px;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  :hover {
    background-color: #12121215;
  }
`

type Props = {
  open: boolean
  content: ReactNode | ReactNode[]
  onClose: () => void
}

const CoreModal = ({ open, content, onClose }: Props) => {
  const { isDesktop, isMobile } = rdd
  const [style, setStyle] = useState<CSSProperties>()

  const mobileStyle: CSSProperties = {
    top: `100vh`,
  }
  const desktopStyle: CSSProperties = {
    top: `50%`,
    transform: 'translateY(-50%)',
  }

  useEffect(() => {
    if (!isDesktop || isMobile) {
      setStyle(mobileStyle)
    } else {
      setStyle(desktopStyle)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktop, isMobile])

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <StyledModal style={style}>
          <CloseStyle onClick={onClose}>
            <img src={CloseIcon} alt="CloseIcon" width={24} height={24} />
          </CloseStyle>
          {content}
        </StyledModal>
      </Fade>
    </Modal>
  )
}

export default CoreModal
